import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";

import { Search } from "../components/Input";
import { ContentWrapper } from "../components/Nav";
import { LeafletMap } from "../components/Map";
import { AddressListing } from "../components/Listing";
import "./styles/Lockers.scss";

class Lockers extends React.Component {
  state = {
    focusedMarker: 0,
    lockers: this.props.userData.lockers || []
  };

  handleAddressClick = e => {
    const clickedID = e.currentTarget.id;
    const number = parseInt(clickedID.substring(clickedID.indexOf("_") + 1));

    this.setState({ focusedMarker: number });
  };

  handleSearch = e => {
    const searchString = e.target.value.toLowerCase();
    let newLockerList = this.props.userData.lockers;

    if (searchString.length > 0) {
      newLockerList = newLockerList.filter(locker => {
        const {
          name,
          address_city,
          address_state,
          address_street,
          address_zip
        } = locker;

        // combine all info into one string
        const lockerString = `${name} ${address_city} ${address_state} ${address_street} ${address_zip}`;
        return lockerString.toLowerCase().indexOf(searchString) > -1;
      });
    }

    this.setState({ lockers: newLockerList });
  };

  render() {
    return (
      <ContentWrapper id="lockerWrapper">
        <Container id="lockerContainer">
          <h2 id="lockerHeader">Lockers</h2>
          <Row id="lockerRow">
            <Col sm={8} id="mapCol">
              <LeafletMap
                markers={this.state.lockers.map(address => {
                  const { lat, lng, name } = address;
                  return { lat, lng, name };
                })}
                focusOnMarker={this.state.focusedMarker}
                containerStyle={{ height: "100%" }}
              />
            </Col>
            <Col sm={4} id="addressListCol">
              <div id="addressBlueContainer">
                <Search
                  placeholder="Search lockers"
                  onChange={this.handleSearch}
                />
                <div
                  style={{
                    flex: 1,
                    overflowX: "hidden",
                    overflowY: "auto",
                    marginTop: 15
                  }}
                >
                  {this.state.lockers.length > 0 ? (
                    this.state.lockers.map((address, index) => {
                      const {
                        address_city,
                        address_state,
                        address_zip
                      } = address;
                      const addressRemainder = `${address_city}, ${address_state} ${address_zip}`;

                      return (
                        <AddressListing
                          key={index}
                          pinNumber={index}
                          name={address.name}
                          street={address.address_street}
                          addressRemainder={addressRemainder}
                          clickAddress={this.handleAddressClick}
                        />
                      );
                    })
                  ) : (
                    <p style={{ width: "100%", textAlign: "center" }}>
                      No lockers found in your area :(
                    </p>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </ContentWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Lockers);
